// *********************
// CardHorarios
// components/Agendar/horarios.jsx
// autor: W de Paula/ microvolution informática / IA 
// data: 15/06/24 - 10:25h
// *********************



import React from 'react';
import './horarios.css';

const CardHorarios = ({ horarios, onSelectHorario }) => {
    return (
        <div className="horarios-container">
            {/* <p className="text-waring">carregando horários...</p> */}
            {horarios.length === 0 ? (
                <p className="text-danger">Nenhum horário disponível para este dia</p>
            ) : (
                <div className="horarios-scrollable">
                    {horarios.map((hora, index) => (
                        <button
                            key={index}
                            className={`horario-button ${hora.selected ? 'selected' : ''}`}
                            onClick={() => onSelectHorario(hora)}
                        >
                            {hora.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default CardHorarios;
